// maybe we should ditch that since we don't really have consistant design scales and styles
// right now it doesn't differ from just typing px straight
export type Spacing = typeof spacing;
export const spacing = {
  S0p: '1px',
  S0pp: '2px',
  S1m: '3px',
  S1: '4px',
  S1p: '5px',
  S2mm: '6px',
  S2m: '7px',
  S2: '8px',
  S2p: '9px',
  S3mm: '10px',
  S3m: '11px',
  S3: '12px',
  S3pp: '13px',
  S3p: '14px',
  S4m: '15px',
  S4: '16px',
  S4pp: '18px',
  S5: '20px',
  S6: '24px',
  S7: '28px',
  S8: '32px',
  S9m: '36px',
  S9: '40px',
  S10mm: '44px',
  S10m: '46px',
  S10: '48px',
  S11: '60px',
  S12: '64px',
  S13: '80px',
  S14: '84px',
  S15: '88px',
  S16: '92px',
  S17: '164px',
};
